module.exports = __webpack_public_path__ + "static/media/agoda-badge.831ed0c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agoda-badge.svg
// module id = 1249
// module chunks = 0